module.exports = __webpack_public_path__ + "img/avatar7.c08679dc.png";